<script setup lang="ts">
import { useI18n } from "vue-i18n";

const { t } = useI18n();
</script>

<template>
  <div class="reset-password-success__content">
    <span class="reset-password-success__title h2">{{
      t("reset_password.password_changed_success")
    }}</span>
  </div>
</template>
<style scoped>
.reset-password-success__content {
  display: flex;
  border-radius: 40px;
  padding: 40px;
  gap: 40px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.reset-password-success__title {
  text-align: center;
}

.reset-password-success_third_party button {
  display: flex;
  border-radius: 8px;
  gap: 8px;
  padding: 12px 20px;
}
</style>
